import CountingRuleNote from './CountingRuleNote';

export default CountingRuleNote;

export type { CountingRuleNoteTone, ICountingRuleNoteProps } from './CountingRuleNote';
